import React from 'react';
import PublicPageLayout from '../../components/PublicPageLayout';
import {Clock} from './PSAOperationalStatistics';
import {io} from 'socket.io-client';
import {LoadGraphic} from '../../components/Common';
import {TextButton} from '../../components/Input';
import moment from 'moment';
import u from '../../utilities/Utilities';
import store from 'store';
import {Link} from 'react-router-dom';
import "../../styles/dashboards/psa-dashboards.scss";
import "../../styles/dashboards/psa-ppr-dorm-layout.scss";

export default class PSAPPRDormLayout extends React.Component{

    tableRows=10;

    pollInterval=300000;

    dormID = this.props.match.params.dormID;

    state={
        content:[],
        instantiated:false,
        defaultView:true,
    };

    componentDidMount=()=>{
        this.getContent();

        this.updateInterval=setInterval(()=>{
            this.setState({update:!this.state.update});
        },5000);

        this.contentInterval=setInterval(()=>{
            this.getContent();
        },this.pollInterval);
    }

    componentWillUnmount=()=>{
        clearInterval(this.contentInterval);
        clearInterval(this.updateInterval);
    }

    getContent=()=>{
        this.setState({error:""});
        u.post({
            url:"/api/get-dashboard-content",
            data:{
                dormID:this.dormID,
                type:"TeeUp Dormitory Layout",
            },
            success:(content)=>{
                this.setState({
                    content:content,
                    instantiated:true
                });
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getScrollWidth=(content)=>{
        const blockMargin=10;
        const tableWidth = content.map((building)=>{
            const maxRooms=Math.max(...(building.levels.map((rooms)=>{return rooms.length})));
            return (62 + (57*maxRooms));
        });
        let width=0;
        for(var i=0; i<tableWidth.length; i++){
            width += blockMargin + tableWidth[i];
        }
        return width+"px";
    }

    onNav=(index)=>{
        const element = document.getElementById("block-"+index);
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
    }

    onToggleView=()=>{
        this.setState({defaultView:!this.state.defaultView});
    }

    render=()=>{
        const content=this.state.content;
        const scrollWidth=this.getScrollWidth(content);

        return(
            <PublicPageLayout url="/psa-operational-status" title="PPT 1A"
                              containerStyle={{paddingLeft:"10px",paddingRight:"10px"}}>

                <LoadGraphic active={!this.state.instantiated} text="Preparing"/>

                <div className="psa-dashboard-header-container" style={{height:"20px"}}>
                    <div className="psa-dashboard-header">
                        <div className="pdh-title" style={{textAlign:"left"}}><h2>PPT 1A Dorm Layout</h2></div>
                        <div className='pdh-title right'><h2><Clock/></h2></div>
                    </div>
                </div>

                <div style={{position:"relative",textAlign:"center"}}>
                    {
                        (this.state.defaultView)
                            ?
                            <div>
                                <div className="ppr-dorm-blueprint" style={{width:"1600px",margin:"30px auto"}}>
                                    <img src="/images/dashboard/teeup/teeup-dorm-layout.png"/>
                                    {
                                        content.map(
                                            (item,index)=>{
                                                return (
                                                    <MapNav key={index}
                                                            content={item}
                                                            index={index}
                                                            onClick={this.onNav}
                                                            width="8%"
                                                            fontSize="12px"
                                                            />
                                                )
                                            }
                                        )
                                    }
                                </div>

                                <div className="ppr-content-container" style={{marginTop:"20px"}}>
                                    <div ref="scroll" className="horizontal-scroll-container" style={{width:scrollWidth}}>
                                        {
                                        content.map(
                                            (building,b)=>{
                                                return (
                                                    <div key={b} id={"block-"+b} className="dl-building-container">
                                                        <div className="dl-building-name" style={{backgroundColor:building.buildingColor}}><b>{building.buildingName}</b></div>
                                                        <div className="dl-table-container">
                                                        {
                                                            building.levels.map(
                                                                (rooms,index,arr)=>{
                                                                    const hasSickbay = (rooms.filter((item)=>{return item.type == "sickbay"}).length > 0);
                                                                    return (
                                                                        <div key={index} className={"dl-table" + ((index == 0) ? " first" : "") + ((index == arr.length - 1) ? " last" : "")}>
                                                                            <DLTH hasSickbay={hasSickbay}
                                                                                  />
                                                                            {
                                                                                rooms.map(
                                                                                    (room,r)=>{
                                                                                        return(
                                                                                            <DLTD key={r}
                                                                                                  content={room}
                                                                                                  hasSickbay={hasSickbay}
                                                                                                  />
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="ppr-content-container stacked">
                                {
                                    content.map(
                                        (building,b)=>{
                                            return (
                                                <div key={b} className="dl-building-container stacked">
                                                    <div className="dl-building-name" style={{backgroundColor:building.buildingColor}}><b>{building.buildingName}</b></div>
                                                    <div className="dl-table-container">
                                                    {
                                                        building.levels.map(
                                                            (rooms,index,arr)=>{
                                                                const hasSickbay = (rooms.filter((item)=>{return item.type == "sickbay"}).length > 0);
                                                                return (
                                                                    <div key={index} className={"dl-table" + ((index == 0) ? " first" : "") + ((index == arr.length - 1) ? " last" : "")}>
                                                                        <DLTH hasSickbay={hasSickbay}
                                                                              stacked={true}
                                                                              />
                                                                        {
                                                                            rooms.map(
                                                                                (room,r)=>{
                                                                                    return(
                                                                                        <DLTD key={r}
                                                                                              content={room}
                                                                                              hasSickbay={hasSickbay}
                                                                                              stacked={true}
                                                                                              />
                                                                                    )
                                                                                }
                                                                            )
                                                                        }
                                                                    </div>
                                                                )
                                                            }
                                                        )
                                                    }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    )
                                }
                            </div>
                    }
                    <div style={{textAlign:"center",margin:"20px auto"}}>
                        <TextButton onClick={this.onToggleView}>
                          {
                              (this.state.defaultView)
                                  ?
                                  "See Stacked View"
                                  :
                                  "See Blueprint View"
                          }
                        </TextButton>
                    </div>
                </div>

            </PublicPageLayout>
        )
    }
}

export class DLTD extends React.Component{
    render=()=>{
        const content=this.props.content
        const hasSickbay=this.props.hasSickbay;
        const hasSickbayType=(typeof content.sickbayType != "undefined");

        if(content.type == "repurposed"){
            return (
                <div className="dl-td-container repurposed">
                    <div className="dl-td" style={{backgroundColor:content.roomColor}}>
                        <Link className="dl-td-link" to={(content.type=="sickbay") ? "/estate-list/sickbay/"+content.roomID : "/estate-list/room/"+content.roomID}>{content.roomName}</Link>
                    </div>
                    {
                        (this.props.stacked)
                            ?
                            null
                            :
                            <div className="dl-td"><span style={{opacity:0}}>EMPTY</span></div>
                    }
                    <div className="dl-td"><span style={{opacity:0}}>EMPTY</span></div>
                    <div className="dl-td">{content.repurposedTo}</div>
                    {
                        (this.props.stacked)
                            ?
                            null
                            :
                            <div className="dl-td"><span style={{opacity:0}}>EMPTY</span></div>
                    }
                    <div className="dl-td"><span style={{opacity:0}}>EMPTY</span></div>
                </div>
            )
        }

        return (
            <div className="dl-td-container">
                <div className="dl-td" style={{backgroundColor:content.roomColor}}>
                    <Link className="dl-td-link" to={(content.type=="sickbay") ? "/estate-list/sickbay/"+content.roomID : "/estate-list/room/"+content.roomID}>{content.roomName}</Link>
                </div>
                {
                    (this.props.stacked)
                        ?
                        null
                        :
                        <div className="dl-td">{content.capacity}</div>
                }
                {
                    (this.props.stacked)
                        ?
                        null
                        :
                        <div className="dl-td">{content.occupancy}</div>
                }
                <div className="dl-td">
                    {(content.clientCode) ? content.clientCode : <span style={{opacity:0}}>EMPTY</span>}
                </div>
                <div className="dl-td">
                    {(content.nationality) ? content.nationality : <span style={{opacity:0}}>EMPTY</span>}
                </div>
                <div className={"dl-td " + ((content.vacancy > 0) ? " available" : "")}>
                    {(content.vacancy) ? <b>{content.vacancy}</b> : <span style={{opacity:0}}>EMPTY</span>}
                </div>
            </div>
        )
    }
}

export class DLTH extends React.Component{
    render=()=>{
        return (
            <div className="dl-th-container">
                <div className="dl-th first">UNIT</div>
                {
                    (this.props.stacked)
                        ?
                        null
                        :
                        <div className="dl-th">MAX</div>
                }
                {
                    (this.props.stacked)
                        ?
                        null
                        :
                        <div className="dl-th">OCC</div>
                }
                <div className="dl-th">CLN</div>
                <div className="dl-th">NAT</div>
                <div className="dl-th">AVAIL</div>
            </div>
        )
    }
}

export class MapNav extends React.Component{

    render=()=>{
        const content=this.props.content;

        return (
            <div className="map-nav" style={{
                  top:content.map.y,
                  left:content.map.x,
                  width:this.props.width,
                  fontSize:this.props.fontSize,
                }} onClick={
                  ()=>{
                      this.props.onClick(this.props.index);
                  }
                }
                >
                <div className="map-nav-name"><b>{content.buildingName} {(content.buildingLabel) ? content.buildingLabel : null}</b></div>
                <div className="map-nav-capacity"><b>{content.occupancy}/{content.capacity} pax</b></div>
            </div>
        )
    }
}
